import { SafeAreaView } from 'react-native-safe-area-context';
import * as React from 'react';
import Images from '../../state/stores/Image/images';
import Show from '../Show/Show';
import {COLORS} from '../../config/designSystem/Colors';
import { HeaderParamList } from '../../types/navigation';
import { Image, StyleSheet, TouchableOpacity, View } from 'react-native';
import { MaterialIcons } from '@expo/vector-icons';
import { isIos } from '../../config/designSystem/Layout';
import { useAvailableDimensions } from '../../hooks/ui/useAvailableDimensions';


type HeaderProps = HeaderParamList['Header'];


export const MIN_WIDTH = 150;

export const PublicPagesHeader = ({onPress, withContactToSupport}: HeaderProps)  => {
  const { width, height } = useAvailableDimensions();
  const MARGIN_VERTICAL=  isIos?0: height*0.05;
  // shrink the logo so that the login form doesn't get squashed when the keyboard is showing
  const HEIGHT = Math.min(250, Math.max(60, 0.05*height));
  const WIDTH = HEIGHT;

  const RIGHT_OF_SUPPORT = Math.max(width/3 - 200, 0);
  return (
    <SafeAreaView style={[styles.container, {
      height: HEIGHT,
      marginTop: MARGIN_VERTICAL,
      minWidth:MIN_WIDTH}]}>
      <Image
        source={Images.logo.logoAndText}
        style={ { resizeMode: 'contain', width: WIDTH, height: HEIGHT }}
        height={HEIGHT}
        width={WIDTH}
      />
      <Show when={withContactToSupport}>
        <View style={{position:'absolute',right:RIGHT_OF_SUPPORT}}>
          <TouchableOpacity onPress={onPress}>
            <MaterialIcons name='contact-support' size={40} color={COLORS.brand[500]}/>
          </TouchableOpacity>
        </View>
      </Show>
    </SafeAreaView >
  );
};



const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    marginHorizontal: 20,

  },
});
